var _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOtherError = function SvgOtherError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 250,
    fill: "none",
    viewBox: "0 0 256 250"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3992",
    d: "M55 74.219h82v94.726H55z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B216B",
    d: "M137 74.219h82v80.726c0 7.732-6.268 14-14 14h-68z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1BDFF",
    d: "M218.84 57.618H55v17h18.33l145.51-.532z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.033,
    cy: 67.047,
    fill: "#1B216B",
    rx: 3.072,
    ry: 3
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.248,
    cy: 67.047,
    fill: "#1B216B",
    rx: 3.072,
    ry: 3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.465,
    cy: 67.047,
    fill: "#1B216B",
    rx: 3.072,
    ry: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F0EE",
    d: "M191 91.797H83v7.812h108zM191 112.305H83v7.812h108z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA5B",
    d: "M55 206.064c22.091 0 40-17.488 40-39.062S77.09 127.94 55 127.94s-40 17.489-40 39.062c0 21.574 17.908 39.062 40 39.062"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD008",
    d: "M55 127.94h-.272v78.114H55c22.093 0 40-17.487 40-39.062 0-21.576-17.907-39.062-40-39.062z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#4154AE",
    d: "M72.5 166.992c0-3.31-.962-6.398-2.63-9.015L45.77 181.514A17.7 17.7 0 0 0 55 184.082c9.665 0 17.5-7.651 17.5-17.09m-35 0c0 3.658 1.175 7.045 3.18 9.825l24.38-23.809A17.7 17.7 0 0 0 55 149.902c-9.665 0-17.5 7.652-17.5 17.09m42 0c0 13.214-10.969 23.926-24.5 23.926-6.56 0-12.522-2.522-16.917-6.619-4.668-4.353-7.583-10.5-7.583-17.307 0-13.214 10.969-23.926 24.5-23.926 6.97 0 13.265 2.847 17.722 7.406 4.196 4.291 6.778 10.115 6.778 16.52"
  })));
};
export { SvgOtherError as Icon };
export default __webpack_public_path__ + "static/media/e75e98d682a68473741b30ee4bd516f3.svg";